import history from "./router/history";
import Media from "./Medias/Media";
import ExportMedia from "./ExportMedias/ExportMedia";
import InfosMedia from "./InfosMedias/InfosMedia";
import Podcast from "./Podcast/Pages/Podcast";
import { Switch, Route, Redirect, BrowserRouter as Router } from "react-router-dom";
import "./i18n";
import { addMedia } from "./addMedia/addMedia";
import { AddPendingVideo } from "./addMedia/components/addPendingVideo";
import { EditVideo } from "./addMedia/components/editVideo";
import EditPodcast from "./Podcast/Components/addEdit/EditPodcast";
import AddPodcast from "./Podcast/Components/addEdit/AddPodcast";
import AddPodcastMain from "./Podcast/Components/addEdit/AddPodcastMain";
import ChangeVideoSource from "./addMedia/components/ChangeVideoSource";
import { AddAudioDescription } from "./AddAudioDescription/AddAudioDescription";
import { ControleMedia } from "./addMedia/controleMedia";
import PlayList from "./PlayList/PlayList";
import Dashboard from "./Dashboard/Dashboard";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUserData } from "./userData/userDataActions";
import i18next from 'i18next';
import { ControleUrllMedia } from "./addMedia/ControleUrllMedia";
import ShowEmailModal from "./Medias/modals/ShowEmailModal";
import { useAppSelector } from "./redux/hooks";
import Hooks from "./Medias/utils/hooks";
import Cookies from "js-cookie";

const SAFE_COLOR = /^(?:#[0-9a-f]{3,4}|#[0-9a-f]{6}|#[0-9a-f]{8}|rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)|[a-z]{3,20})$/i;
const DEFAULT_COLOR = "#1890ff";

function getSafeColor(value) {
  if (typeof value !== "string" || value.length > 40 || !SAFE_COLOR.test(value)) return DEFAULT_COLOR;
  return typeof CSS !== "undefined" && CSS.supports("color", value) ? value : DEFAULT_COLOR;
}

function App() {
	const token = Cookies.get("authToken");
	const dispatch = useDispatch();
	const urlParams = new URLSearchParams(window.location.search);
	const modalToOpen = useAppSelector((state) => state.MediaReducer.modalToOpen);
	const modules = useAppSelector((state) => state.ReducerUserData.modules);
	const {idVideo}= Hooks();
	  useEffect(() => {
      const queryColor = urlParams.get("color");
      const storedColor = localStorage.getItem("color");
      const colorParam = queryColor !== null ? queryColor : storedColor;

      if (colorParam !== null) {
        const safeColor = getSafeColor(colorParam);
        localStorage.setItem("color", safeColor);
        document.body.classList.add("custom-theme");
        document.documentElement.style.setProperty("--primary-color", safeColor);
      }
      if (Object.keys(modules)?.length !== 0 && !modules?.custom_theme_right) {
        localStorage.removeItem("color");
        document.body.classList.remove("custom-theme");
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [urlParams.get("color"),modules]);
  	const video = useAppSelector((state) => state.MediaReducer.urlVideo);
useEffect(() => {
    const applyTheme = (theme) => {
        const body = document.body;
        const html = document.documentElement;
        
        // Remove both classes first
        body.classList.remove('dark-theme', 'light-theme');
        html.classList.remove('dark-theme', 'light-theme');
        
        if (theme === 'dark') {
            body.classList.add('dark-theme');
            html.classList.add('dark-theme');
            
            // Apply inline styles as backup
            body.style.backgroundColor = '#1e1e1e';
            body.style.color = '#e0e0e0';
            html.style.backgroundColor = '#1e1e1e';
        } else {
            body.classList.add('light-theme');
            html.classList.add('light-theme');
            
            // Reset to light theme
            body.style.backgroundColor = '#ffffff';
            body.style.color = '#212121';
            html.style.backgroundColor = '#ffffff';
        }
    };

    // Listen for theme updates from parent
    const handleThemeMessage = (event) => {
        if (event.data && event.data.info === 'updateTheme') {
            const theme = event.data.theme;
            applyTheme(theme);
            localStorage.setItem('theme', theme);
        }

        // Clear theme when user disconnects from BO
        if (event.data && event.data.info === 'clearTheme') {
            localStorage.removeItem('theme');
            // applyTheme('light');
        }
    };

    window.addEventListener('message', handleThemeMessage);
    
    // Apply initial theme from localStorage
    const savedTheme = localStorage.getItem('theme') || 'light';
    applyTheme(savedTheme);

    return () => {
        window.removeEventListener('message', handleThemeMessage);
    };
	// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
	useEffect(()=>{
		const lang = urlParams.get('lang') 
	  
		  if(lang==="en" || lang==="fr"){
			i18next.changeLanguage(lang)
		  }
		  // eslint-disable-next-line react-hooks/exhaustive-deps
		},[urlParams.get('lang')])
	useEffect(() => {
		dispatch(getUserData())
		localStorage.setItem("authToken", token);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<div className="App">
			<Router history={history}>
				<Switch>
					<Redirect exact from="/medias" to="/ws-media/Medias" />
					<Redirect exact from="/ws-media" to="/ws-media/Medias" />
					<Redirect exact from="/" to="/ws-media/Medias" />
					<Redirect exact from="/exportMedia" to="/ws-media/exportMedia" />
					<Redirect exact from="/video/:filename/:id/add" to="/ws-media/video/:filename/:id/add" />
					<Redirect
						exact
						from="/video/change-video-source/:filename/:id/:mediaid"
						to="/ws-media/video/change-video-source/:filename/:id/:mediaid"
					/>
					<Redirect
						exact
						from="/video/:filename/:id/edit"
						to="/ws-media/video/:filename/:id/edit"
					/>
					<Redirect exact from="/video/infosMedia" to="/ws-media/video/infosMedia" />
					<Redirect
						exact
						from="/secondpageupload/video/:filename/:id"
						to="/ws-media/secondpageupload/video/:filename/:id"
					/>
					<Redirect exact from="/AddMedia" to="/ws-media/AddMedia" />
					<Redirect
						exact
						from="/addAudioDescription/:videoId/:mediaId"
						to="/ws-media/addAudioDescription/:videoId/:mediaId"
					/>
					<Redirect
						exact
						from="/editAudioDescription/:videoId/:mediaId"
						to="/ws-media/editAudioDescription/:videoId/:mediaId"
					/>
					<Redirect exact from="/secondPageAdd" to="/ws-media/secondPageAdd" />
					<Redirect exact from="/secondPageUpload" to="/ws-media/secondPageUpload" />
					<Redirect exact from="/podcast/upload" to="/ws-media/podcast/upload" />
					<Redirect exact from="/upload" to="/ws-media/upload" />
					<Redirect exact from="/edit/:params" to="/ws-media/edit/:params" />
					<Redirect exact from="/podcasts" to="/ws-media/podcasts" />
					<Redirect exact from="/playList" to="/ws-media/playList" />
					<Redirect exact from="/Dashboard" to="/ws-media/Dashboard" />
					<Route path="/ws-media/Dashboard" component={Dashboard} />
					<Route path="/ws-media/playList" component={PlayList} />
					<Route path="/ws-media/Medias" component={Media} />
					<Route path="/ws-media/podcasts/" component={Podcast} />
					<Route exact path="/ws-media/Medias" component={Media} />
					<Route exact path="/ws-media/exportMedia" component={ExportMedia} />
					<Route path="/ws-media/video/:filename/:id/edit" component={EditVideo} />
					<Route exact path="/ws-media/video/:filename/:id/add" component={AddPendingVideo} />
					<Route
						exact
						path="/ws-media/video/change-video-source/:filename/:id/:mediaid"
						component={ChangeVideoSource}
					/>
					<Route exact path="/ws-media/infosMedia" component={InfosMedia} />
					<Route
						exact
						path="/ws-media/secondpageupload/video/:filename/:id"
						component={ControleMedia}
					/>
					<Route
						exact
						path="/ws-media/pageuploadurl/video/:filename"
						component={ControleUrllMedia}
					/>

					<Route exact path="/ws-media/AddMedia" component={addMedia} />
					<Route
						exact
						path="/ws-media/addAudioDescription/:videoId/:mediaId"
						component={AddAudioDescription}
					/>
					<Route
						exact
						path="/ws-media/editAudioDescription/:videoId/:mediaId"
						component={AddAudioDescription}
					/>
					<Route exact path="/ws-media/pageuploadurl" component={ControleUrllMedia} />
					<Route exact path="/ws-media/secondPageAdd" component={ControleMedia} />
					<Route exact path="/ws-media/secondPageUpload" component={ControleMedia} />
					<Route exact path="/ws-media/podcast/upload" component={AddPodcast} />
					<Route exact path="/ws-media/upload" component={AddPodcastMain} />
					<Route exact path="/ws-media/edit/:params" component={EditPodcast} />
				</Switch>
			</Router>
			{modalToOpen && modalToOpen === "showEmailModal" && (<ShowEmailModal video={video} idVideo={idVideo} />)}
		</div>
	);
}

export default App;
